import React, { useEffect, useState, useCallback, useRef, memo } from "react";
import { Input, Button, Spinner } from "reactstrap";
import { PDFViewer, PDFViewerTool } from "@progress/kendo-react-pdf-viewer";
import ReactPlayer from "react-player";
import Plyr from "plyr-react";
import "plyr-react/plyr.css";
import VideoMediaPlayer from "./VideoMediaPlayer";
import AudioMediaPlayer from "./AudioMediaPlayer";

import { getUrlParameter } from "../../../utils/actions";
import { getAuthToken, getTeacherAuthToken } from "../../../utils/auth";

import setting from "../../../assets/images/icons/console-6.svg";
import lightSetting from "../../../assets/images/icons/console-6.svg";

import widgetWorks from "../../../assets/images/icons-component/works.png";

import { screenState, setError } from "../../../store/screen/slice";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";

const Index = (props: any) => {
  const { username } = useAppSelector(state => screenState(state));
  const dispatch = useAppDispatch();
  const {
    config,
    insideRef,
    insideSwitch,
    openOption,
    onUpdate,
    actionEnd,
    inside,
  } = props;
  const [dataType, setDataType] = useState<any>(null);
  const [title, setTitle] = useState<any>(null);
  const [description, setDescription] = useState<any>(null);
  const [source, setSource] = useState<any>(null);
  const [icon, setIcon] = useState<any>(null);
  const [fileName, setFileName] = useState<any>(null);
  const [onload, setOnload] = useState<boolean>(false);

  useEffect(() => {
    const worksObj = config.data.workObj
      ? JSON.parse(config.data.workObj)
      : null;
    if (worksObj) {
      setOnload(true);
      setDataType(null);
      setTitle(null);
      setDescription(null);
      setSource(null);
      setIcon(null);

      const content = worksObj.content ? JSON.parse(worksObj.content) : null;
      if (worksObj.type === "txt") {
        setDataType("txt");
        setTitle(worksObj.title);
        setDescription(worksObj.description);
        setOnload(false);
      } else if (worksObj.type === "link") {
        setDataType("link");
        setSource(content.link);
        getLinkPreviewData(content.link);
      } else if (worksObj.type === "yt") {
        setDataType("yt");
        setSource(content.link);
      } else if (worksObj.type === "file") {
        if (content.mime === "application/pdf") {
          setDataType("pdf");
          setSource(`${process.env.REACT_APP_API_URL}/image/${content.path}`);
          setOnload(false);
        } else if (content.mime.indexOf("image") >= 0) {
          setDataType("image");
          setSource(`${process.env.REACT_APP_API_URL}/image/${content.path}`);
          setOnload(false);
        } else if (content.mime.indexOf("video") >= 0) {
          setDataType("video");
          setSource(`${process.env.REACT_APP_API_URL}/image/${content.path}`);
        } else if (content.mime.indexOf("audio") >= 0) {
          setDataType("audio");
          setSource(`${process.env.REACT_APP_API_URL}/image/${content.path}`);
        } else {
          setDataType("download");
          setSource(`${process.env.REACT_APP_API_URL}/image/${content.path}`);
          setFileName(content.filename);
          setOnload(false);
        }
        setTitle(worksObj.title);
        setDescription(worksObj.description);
      }
    }
  }, [config.data.workObj]);

  async function getLinkPreviewData(source: any) {
    const BoardId = getUrlParameter("board");
    const apiUrl = `${process.env.REACT_APP_API_URL}/api/elements/url/${BoardId}`;
    let accessToken = "";
    let token = null;
    if (getAuthToken()) {
      token = getAuthToken();
    } else if (getTeacherAuthToken()) {
      token = getTeacherAuthToken();
    }
    if (token) {
      accessToken = token;
    }

    fetch(apiUrl, {
      method: "POST",
      headers: {
        userToken: `${accessToken}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        url: source,
      }),
    })
      .then(response => response.json())
      .then(data => {
        if (data.status != "SUCCESS") {
          setTitle("");
          setDescription("");
          setIcon("");
          setOnload(false);
          throw data;
        } else {
          setTitle(data.data.title);
          setDescription(data.data.description);
          setIcon(data.data.icon);
          setOnload(false);
        }
      })
      .catch(e => {
        console.log("error", e);
        setTitle("");
        setDescription("");
        setIcon("");
        setOnload(false);

        dispatch(setError("連結資訊取得失敗"));
      });
  }

  const downloadFile = async () => {
    const blob: any = await fetch(source).then(r => r.blob());
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  useEffect(() => {}, [source]);

  const tools: PDFViewerTool[] = [
    "pager",
    "spacer",
    "zoomInOut",
    "zoom",
    "selection",
    "spacer",
    "search",
  ];

  return (
    <React.Fragment>
      {dataType ? (
        <div style={{ height: "100%", width: "100%", position: "absolute" }}>
          <div
            className={`work-data relative flex h-full flex-col items-center justify-center overflow-hidden ${
              onload ? "work-on-loding" : ""
            }`}
            style={{ cursor: "auto" }}
          >
            {dataType === "pdf" ? (
              <PDFViewer
                url={source}
                tools={tools}
                defaultZoom={1}
                style={{ height: "100%", width: "100%" }}
              />
            ) : null}
            {dataType === "image" ? (
              <img className="work-img" src={source} alt="" />
            ) : null}
            {dataType === "txt" ? (
              <div className="work-txt">{description}</div>
            ) : null}
            {dataType === "yt" ? (
              <div className="work-yt">
                <ReactPlayer
                  src={source}
                  className="react-player"
                  controls
                  width="100%"
                  height="100%"
                  onReady={() => {
                    setOnload(false);
                  }}
                />
              </div>
            ) : null}
            {dataType === "video" ? (
              <div className="work-video">
                <VideoMediaPlayer source={source} setOnload={setOnload} />
              </div>
            ) : null}
            {dataType === "audio" ? (
              <div className="work-audio">
                <AudioMediaPlayer source={source} setOnload={setOnload} />
              </div>
            ) : null}
            {dataType === "link" ? (
              <div className="work-link">
                <div className="work-link-box">
                  <div className="link-icon">
                    <img src={`data:image/jpeg;base64, ${icon}`} alt="" />
                  </div>
                  <div className="link-title">{title}</div>
                  <div className="link-description">{description}</div>
                  <Button
                    color="light"
                    className="ts-playBtn settingBtn btn-load rounded-pill text-sm px-4 h-12 font-semibold"
                    onClick={(e: any) => {
                      window.open(source, "_blank");
                    }}
                  >
                    <div className="relative justify-center h-100 w-100">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 512 512"
                      >
                        {/* <!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--> */}
                        <path d="M320 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h82.7L201.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L448 109.3V192c0 17.7 14.3 32 32 32s32-14.3 32-32V32c0-17.7-14.3-32-32-32H320zM80 32C35.8 32 0 67.8 0 112V432c0 44.2 35.8 80 80 80H400c44.2 0 80-35.8 80-80V320c0-17.7-14.3-32-32-32s-32 14.3-32 32V432c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16H192c17.7 0 32-14.3 32-32s-14.3-32-32-32H80z" />
                      </svg>
                      <span>開啟</span>
                    </div>
                  </Button>
                </div>
              </div>
            ) : null}
            {dataType === "download" ? (
              <div className="work-download">
                <div className="work-download-box">
                  <div className="download-filename">{fileName}</div>
                  <Button
                    color="light"
                    className="ts-playBtn settingBtn btn-load rounded-pill text-sm px-4 h-12 font-semibold"
                    onClick={(e: any) => {
                      downloadFile();
                    }}
                  >
                    <div className="relative justify-center h-100 w-100">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 512 512"
                      >
                        {/* <!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--> */}
                        <path d="M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V274.7l-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 274.7V32zM64 352c-35.3 0-64 28.7-64 64v32c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V416c0-35.3-28.7-64-64-64H346.5l-45.3 45.3c-25 25-65.5 25-90.5 0L165.5 352H64zm368 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z" />
                      </svg>
                      <span>下載</span>
                    </div>
                  </Button>
                </div>
              </div>
            ) : null}

            {/*  */}
            {/* {!dataType? (
              <div className="work-ready">
                <div className="widget-head">
                  <img className="widget-img-icon" src={widgetWorks} alt="" />
                </div>
                <p className="text-dark-500 mb-6 px-4 text-center text-xl font-semibold transition-[color]">打開設定以選擇要預覽的作業</p>
                <Button
                  color="light"
                  className="ts-playBtn settingBtn btn-load rounded-pill text-sm px-4 h-12 font-semibold"
                  onClick={(e: any) => {openOption()}}
                  data-interaction-target-type="false"
                  style={{ "--src": `url(${setting})`, "--hover": `url(${lightSetting})` }}
                >
                  <div className="relative justify-center h-100 w-100">
                    <span className="flex items-center justify-center w-100">
                      <div className="settingIcon"></div>
                      打開設定
                    </span>
                  </div>
                </Button>
              </div>
            ) : null} */}
          </div>

          {onload ? (
            <div className="work-data relative flex h-full flex-col items-center justify-center overflow-hidden">
              <div className="work-loading">
                <Spinner color="dark"> Loading... </Spinner>
              </div>
            </div>
          ) : null}
        </div>
      ) : (
        <div
          className="absolute top-0 start-0 origin-left-top"
          style={{ ...inside }}
        >
          <div style={{ height: "100%", width: "100%", position: "absolute" }}>
            <div
              className={`work-data relative flex h-full flex-col items-center justify-center overflow-hidden ${
                onload ? "work-on-loding" : ""
              }`}
              style={{ cursor: "auto" }}
            >
              <div className="work-ready">
                <div className="widget-head">
                  <img className="widget-img-icon" src={widgetWorks} alt="" />
                </div>
                <p className="text-dark-500 mb-6 px-4 text-center text-xl font-semibold transition-[color]">
                  作業
                </p>
                <Button
                  color="light"
                  className="ts-playBtn settingBtn btn-load rounded-pill text-sm px-4 h-12 font-semibold"
                  onClick={(e: any) => {
                    openOption();
                  }}
                  data-interaction-target-type="false"
                >
                  <div className="relative justify-center h-100 w-100">
                    <span className="flex items-center justify-center w-100">
                      開啟
                    </span>
                  </div>
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

export default memo(Index);
